/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const wrapAll = (
  productItem,
  targetClasses,
  parentClass,
  requiredClass = "required-class"
) => {
  if (!productItem) return;
  let parent = productItem.querySelector(parentClass);
  if (!parent) return;
  let wrapper = document.createElement("div");
  wrapper.classList.add(requiredClass);

  if (productItem.getElementsByClassName(requiredClass).length === 0) {
    for (let targetClass of targetClasses) {
      let target = productItem.querySelectorAll(targetClass);
      if (!target) continue;
      target.forEach((child) => wrapper.append(child));
    }
    parent.append(wrapper);
  } else {
    for (let targetClass of targetClasses) {
      let target = productItem.querySelectorAll(targetClass);
      if (!target) continue;
      target.forEach((child) =>
        productItem.querySelector("." + requiredClass).append(child)
      );
    }
  }

  return wrapper;
};

const buildQuickItemSwatch = (data) => {
  let html = '<form method="post" action="/cart/add">';
  html +=
    '<input type="hidden" name="id" class="poption-id" value="' +
    data.variants[0].id +
    '" />';
  html +=
    '<input min="1" type="number" class="hidden-ele" id="quantity" name="quantity" value="1"/>';
  html += '<ul id="product-select">';
  const firstVariantID = data.variants[0].id;
  let currentCurrencyCode = "usd";
  if (
    window &&
    window.BOLD &&
    window.BOLD.subscriptions &&
    window.BOLD.subscriptions.config &&
    window.BOLD.subscriptions.config.currencyCode
  ) {
    currentCurrencyCode =
      window.BOLD.subscriptions.config.currencyCode.toLowerCase();
  }
  const addToCartText = "Add to cart";
  const notifyMeText = "Notify me";
  data.variants.forEach(function (variant) {
    let priceCur = variant.price;
    if (variant["price_" + currentCurrencyCode]) {
      priceCur = variant["price_" + currentCurrencyCode];
      priceCur = formatMoney(
        priceCur,
        moneyFormats[currentCurrencyCode.toUpperCase()]
          .money_with_currency_format
      );
    }
    if (variant.title != "Default Title") {
      if (variant.available) {
        html +=
          '<li class="product-option ' +
          variant.available +
          '" data-price="' +
          priceCur +
          '"   data-value="' +
          variant.id +
          '" onclick="switchSwatches(this)">';
        const beatles = variant.title.split("-");
        html += '<span class="ptitle">' + beatles[0] + "</span>";
        if (typeof beatles[1] !== "undefined") {
          html += '<span class="pprice">' + beatles[1] + "</span>";
        }
      } else {
        html +=
          '<li class="product-option notify-me-bis" data-price="' +
          priceCur +
          '"   data-value="' +
          variant.id +
          '" onclick="notifyMeWhenBIS(this)">';
        html +=
          '<span class="ptitle">' +
          variant.title +
          " - " +
          notifyMeText +
          "</span>";
      }
      html += "</li>";
    } else {
      if (variant.available) {
        html +=
          '<li class="product-option sd ' +
          variant.available +
          '" data-price="' +
          priceCur +
          '"   data-value="' +
          variant.id +
          '" onclick="switchSwatches(this)"><span class="ptitle">Add to cart</span>';
      } else {
        html +=
          '<li class="product-option notify-me-bis" data-price="' +
          priceCur +
          '"   data-value="' +
          variant.id +
          '" onclick="notifyMeWhenBIS(this)">';
        html += '<span class="ptitle">' + notifyMeText + "</span>";
      }
      html += "</li>";
    }
  });
  html += "</ul>";
  html += '<p class="close-pointer-p" onclick="clostSwatchOption(this)">x</p>';
  html += '<div class="addtocart-div hidden-ele">';
  html +=
    '<input type="submit" value="Add to cart" class="ajax-submit btn ajax-cart__button button--add-to-cart button" />';
  html += "<span></span>";
  html += "</div>";
  html += "</form>";
  return html;
};

let productIdPosReset = setPosition(1); // do not change this line. The param for this variable need to be 1;
let productIdPos1 = setPosition(7);
let productIdPos2 = setPosition(8);
let productIdPos3 = setPosition(14);
// if (window.innerWidth < 768) {
//   productIdPos1 = setPosition(6);
// }
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
  (registry) => {
    registry.useComponentPlugin("ProductTitle", {
      name: "Change product title",
      enabled: true,
      apply: () => ({
        render(elementModel, currentRenderElement) {
          try {
            // Get the CSS styling data from props and store them in elmStyles object
            const {
              color,
              fontFamily,
              fontSize,
              fontStyle,
              fontWeight,
              textTransform,
              title,
            } = currentRenderElement.props;
            const elmStyles = {
              color,
              fontFamily,
              fontSize,
              fontStyle,
              fontWeight,
              textTransform,
            };

            let titleHTML = `<div class="boost-sd__product-title">${title}</div>`;
            if (title.indexOf("|") !== -1) {
              let pTitleArr = title.split("|");
              if (pTitleArr.length > 1) {
                titleHTML = '<div class="boost-sd__product-title">';
                titleHTML +=
                  '<span class="boost-sd__first-product-title">' +
                  pTitleArr[0] +
                  "</span>";
                titleHTML +=
                  '<span class="boost-sd__last-product-title">' +
                  pTitleArr[1] +
                  "</span>";
                titleHTML += "</div>";
              }
            }
            return createElementFromHTML(titleHTML.trim(), elmStyles); // Return new title elm with h3 and the styles defined in elmStyles
          } catch (error) {
            console.error(error);
            return currentRenderElement; // Fallback -> return the original elm if there is an error
          }
        },
      }),
    });

    registry.useModulePlugin("FilterAPI", {
      name: "Extra params filter in collection page",
      apply(builder) {
        builder.on("methodFulfilled", "get", (payload) => {
          // TODO: do something - ts
          // example add pf_t_tag
          if (payload.result) {
            productIdPosReset =
              payload.result.products.length > productIdPosReset.pos - 1
                ? setPosition(
                    productIdPosReset.pos,
                    payload.result.products[productIdPosReset.pos - 1].id
                  )
                : setPosition(productIdPosReset.pos);
            productIdPos1 =
              payload.result.products.length > productIdPos1.pos - 1
                ? setPosition(
                    productIdPos1.pos,
                    payload.result.products[productIdPos1.pos - 1].id
                  )
                : setPosition(productIdPos1.pos);
            productIdPos2 =
              payload.result.products.length > productIdPos2.pos - 1
                ? setPosition(
                    productIdPos2.pos,
                    payload.result.products[productIdPos2.pos - 1].id
                  )
                : setPosition(productIdPos2.pos);
            productIdPos3 =
              payload.result.products.length > productIdPos3.pos - 1
                ? setPosition(
                    productIdPos3.pos,
                    payload.result.products[productIdPos3.pos - 1].id
                  )
                : setPosition(productIdPos3.pos);
          }
        });
      },
    });

    registry.useComponentPlugin("ProductItem", {
      name: "Customize product card",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            let productData =
              element.getParams()?.props?.product ||
              element.getParams()?.props?.productData ||
              element.getParams()?.props?.data;
            let productItems = document.querySelectorAll(
              '[data-product-id="' + productData.id + '"]'
            );

            // QuickShop
            let quickShopBtn = '<div class="quick-buy-bttn">';
            quickShopBtn +=
              '<a href="javascript:void(0)" class="quick-buy-bttn-anchor" data-href="' +
              Shopify?.routes?.root +
              "/products/" +
              productData.handle +
              '">Quick Buy';
            quickShopBtn += '<div class="quick-buy-detail">';
            quickShopBtn += buildQuickItemSwatch(productData);
            quickShopBtn += "</div>";
            quickShopBtn += "</a>";
            quickShopBtn +=
              '<div data-boost-pfs-quickshop-id="' +
              productData.id +
              '" style="display: none"></div>';
            quickShopBtn += "</div>";

            for (let productItem of productItems) {
              // Add quickshop btn
              if (
                productItem &&
                productItem.querySelector(".quick-buy-bttn") == null
              ) {
                productItem
                  .querySelector(
                    ".boost-sd__product-link:not(.boost-sd__product-link-image)"
                  )
                  .insertAdjacentHTML("beforeend", quickShopBtn);
              }

              // Add custom wrapper to every product item
              wrapAll(
                productItem,
                [".boost-sd__product-info, .quick-buy-bttn"],
                ".boost-sd__product-link:not(.boost-sd__product-link-image)",
                "boost-sd__atc-wl-wrapper"
              );

              // Add Promotion/Addvertiser
              if (
                typeof productItem !== "object" ||
                productIdPosReset.id === productData.id
              ) {
                document
                  .querySelectorAll(".boost-sd__custom-card")
                  .forEach(function (elem) {
                    elem.remove();
                  });
              }
              if (
                productData.id === productIdPos1.id &&
                !document.querySelector(
                  ".boost-sd__custom-quiz-element-" + productIdPos1.id
                )
              ) {
                productItem.insertAdjacentHTML(
                  "afterend",
                  navigateToQuiz(productIdPos1.id, bannerFirstData)
                );
              }
              if (
                productData.id === productIdPos2.id &&
                !document.querySelector(
                  ".boost-sd__custom-discover-element-" + productIdPos2.id
                )
              ) {
                productItem.insertAdjacentHTML(
                  "afterend",
                  discoverElement(productIdPos2.id, metafieldData)
                );
              }
              if (
                productData.id === productIdPos3.id &&
                !document.querySelector(
                  ".boost-sd__custom-quiz-element-" + productIdPos3.id
                )
              ) {
                productItem.insertAdjacentHTML(
                  "afterend",
                  navigateToQuizNew(productIdPos3.id, cardBannerData)
                );
              }
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });

    registry.useComponentPlugin("Sorting", {
      name: "Modify - Recall custom event/function after product grid rendered",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (window.screen.width > 767) {
              // Click event on Sort by button
              const sortBySelector = document.querySelector(
                ".boost-sd__sorting-label"
              );
              const sortByBtn = document.querySelector(
                ".boost-sd__sorting-button"
              );
              if (sortBySelector && sortByBtn) {
                sortBySelector.addEventListener("click", (e) => {
                  sortByBtn.classList.toggle(
                    "boost-sd__sorting-button--active"
                  );
                  if (sortByBtn.querySelector(".boost-sd__sorting-list")) {
                    sortByBtn
                      .querySelector(".boost-sd__sorting-list")
                      .classList.toggle("boost-sd__sorting-list--active");
                  }
                });
              }
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });

    registry.useComponentPlugin("CollectionHeader", {
      name: "Change collection header image",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            if (element.getRootElm().querySelector(".boost-sd__header-image")) {
              if (window.screen.width < 768) {
                if (collectionImage != "" && collectionImage != null) {
                  element.getRootElm().classList.add("boost-custom-image");
                  const imageHTML = `<img src="${collectionImage}" alt="" class="boost-sd__header-image-inner boost-sd__header-image-inner-mobile" sizes="93.74999860301615px" srcset="${collectionImage}&amp;width=800 800w, ${collectionImage}&amp;width=1000 1000w, ${collectionImage}&amp;width=1200 1200w, ${collectionImage}&amp;width=1600 1600w" style="position: absolute;">`;
                  if (
                    !element
                      .getRootElm()
                      .querySelector(".boost-sd__header-image-inner-mobile")
                  ) {
                    element
                      .getRootElm()
                      .querySelector(".boost-sd__header-image")
                      .insertAdjacentHTML("beforeend", imageHTML);
                  }
                }
              } else {
                if (
                  collectionImageDesktop != "" &&
                  collectionImageDesktop != null
                ) {
                  element.getRootElm().classList.add("boost-custom-image");
                  const imageHTML = `<img src="${collectionImageDesktop}" alt="" class="boost-sd__header-image-inner boost-sd__header-image-inner-desktop" sizes="486.4px" srcset="${collectionImageDesktop}&amp;width=800 800w, ${collectionImageDesktop}&amp;width=1000 1000w, ${collectionImageDesktop}&amp;width=1200 1200w, ${collectionImageDesktop}&amp;width=1600 1600w" style="position: absolute;">`;
                  if (
                    !element
                      .getRootElm()
                      .querySelector(".boost-sd__header-image-inner-desktop")
                  ) {
                    element
                      .getRootElm()
                      .querySelector(".boost-sd__header-image")
                      .insertAdjacentHTML("beforeend", imageHTML);
                  }
                }
              }
            }
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  }
);

function createElementFromHTML(htmlString, styles) {
  const div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  // Add styles
  for (const value in styles) {
    if (styles[value] === undefined) {
      delete styles[value];
    }
  }
  Object.assign(div.firstChild.style, styles);

  return div.firstChild;
}
function setPosition(pos, id = "") {
  return {
    id: id,
    pos: pos,
  };
}
function navigateToQuiz(id, bannerFirstData) {
  const { title, link_url, link_text } = bannerFirstData;
  console.log("bannerFirstData >> ", bannerFirstData);
  // const html = `
  //   <a href="https://uk.naak.com/pages/take-the-quiz" class="boost-sd__custom-card boost-sd__custom-quiz-element-${id} quiz-element one-third medium-down--one-half small-down--one-whole column quick-shop--true quick-shop--closed product-6578240225366 js-product_section thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false has-padding-bottom" data-id="8261194645802" data-page="1">
  //     <h4>Which Product is right for you?</h4>
  //     <div class="quick_shop button action_button button--secondary js-quick-shop-link">Take the quiz</div>
  //   </a>
  // `;

  const html = `
    <a href="${
      link_url || "https://uk.naak.com/pages/take-the-quiz"
    }" class="boost-sd__custom-card boost-sd__custom-quiz-element-${id} quiz-element one-third medium-down--one-half small-down--one-whole column quick-shop--true quick-shop--closed product-6578240225366 js-product_section thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false has-padding-bottom" data-id="8261194645802" data-page="1">
      <h4>${title || "Which Product is right for you?"}</h4>
      <div class="quick_shop button action_button button--secondary js-quick-shop-link">${
        link_text || "Take the quiz"
      }</div>
    </a>
  `;
  return html;
}

function navigateToQuizNew(id, cardBannerData) {
  const { title, link_url, link_text, imageUrl, altText } = cardBannerData;
  console.log("cardBannerData >> ", cardBannerData);

  // const html_New = `
  //   <div class="boost-sd__custom-card boost-sd__custom-quiz-element-${id} quiz-element one-third medium-down--one-half small-down--one-whole column quick-shop--true quick-shop--closed product-6578240225366 js-product_section thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false has-padding-bottom" data-id="8261194645802" data-page="1" style="background-image: url('${imageUrl || ''}'); background-color: #fff200; background-size: cover;background-repeat: no-repeat; background-position: center;">
  //     <h4>${title || 'Which Product is right for you?'}</h4>
  //     <a class="quick_shop button action_button button--secondary js-quick-shop-link custom-take-the-quiz" href="${link_url || 'https://uk.naak.com//pages/take-the-quiz'}">${link_text || 'Take the quiz'}</a>
  //   </div>
  // `;

  const html_New = `
      <a href="${
        link_url || "https://uk.naak.com/pages/take-the-quiz"
      }" class="boost-sd__custom-card boost-sd__custom-quiz-element-${id} quiz-element one-third medium-down--one-half small-down--one-whole column quick-shop--true quick-shop--closed product-6578240225366 js-product_section thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false has-padding-bottom" data-id="8261194645802" data-page="1" style="background-image: url('${
    imageUrl || ""
  }'); background-color: #fff200; background-size: cover;background-repeat: no-repeat; background-position: center;">
        <div class="quick_shop button action_button button--secondary js-quick-shop-link custom-take-the-quiz">${
          link_text || "Take the quiz"
        }</div>
      </a>
    `;
  return html_New;
}

function discoverElement(id, metafieldData) {
  const { title, description, link_url, link_text, imageUrl, altText } =
    metafieldData;
  console.log("metafieldData :: ", metafieldData);
  // const html = `
  //   <a href="/products/4-bars-2-protein-powder-servings-discovery-pack" class="boost-sd__custom-card boost-sd__custom-discover-element-${id} discover-element test" data-id="8261194350890" data-page="1">
  //     <div class="discover-element-left">
  //       <h4>Try the Discovery Pack</h4>
  //       <p>Enjoy all the flavours of Näak Ultra Energy™ bars and waffles + get free shipping when you sign up to our newsletter</p>
  //       <div class="button action_button button--secondary js-quick-shop-link">Discover now</div>
  //     </div>
  //     <div class="discover-element-right"><img src="https://cdn.shopify.com/s/files/1/0705/2610/7946/files/Website_2023_-_Discovery_Pack_-_Collection_page_-_652_x_406_px.png?v=1678228414" alt="Discover Bg">
  //     </div>
  //   </a>
  // `;
  const html = `
    <a href="${
      link_url ||
      "https://uk.naak.com/products/4-bars-2-protein-powder-servings-discovery-pack"
    }" class="boost-sd__custom-card boost-sd__custom-discover-element-${id} discover-element test custom-mega-banner" data-id="8261194350890" data-page="1">
      <div class="discover-element-left">
        <h4>${title || "Try the Discovery Pack"}</h4>
        <p>${
          description ||
          "Enjoy all the flavours of Näak Ultra Energy™ bars and waffles + get free shipping when you sign up to our newsletter"
        }</p>
        <div class="button action_button button--secondary js-quick-shop-link">${
          link_text || "Discover now"
        }</div>
      </div>
      <div class="discover-element-right">
      <img src="${
        imageUrl ||
        "https://cdn.shopify.com/s/files/1/0705/2610/7946/files/Website_2023_-_Discovery_Pack_-_Collection_page_-_652_x_406_px.png?v=1678228414"
      }" alt="${altText || "Discover Bg"}">
      </div>
    </a>`;
  return html;
  return html;
}
